module.exports = __webpack_public_path__ + "static/media/font_bold.6e49c1f8.woff";